export const transformCamelCaseToSpaces = (text: string) => {
  return text
    .replaceAll(/([a-z])([A-Z])/g, '$1 $2') // handle camelCase boundaries
    .replaceAll(/([A-Z])([A-Z][a-z])/g, '$1 $2');
};
